import { createMenuProduct } from './menu-item';

export const createBasketItem = ({ quantity = 1, itemPrice = 7.99 }) => ({
  product: createMenuProduct({ index: 0 }),
  quantity,
  itemPrice,
});
